import { useEffect, useRef } from 'react';

/**
 * Native <dialog> wrapper — the browser handles Esc, focus trapping and the
 * backdrop, so this only syncs the open state and closes on a backdrop click.
 */
export default function Modal({ open, title, onClose, className = '', children }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className={`modal ${className}`.trim()}
      onClose={onClose}
      onClick={(event) => {
        if (event.target === ref.current) onClose();
      }}
    >
      <div className="modal-head">
        <h2>{title}</h2>
        <button type="button" className="modal-x" onClick={onClose} aria-label="Close">
          &times;
        </button>
      </div>
      <div className="modal-body">{children}</div>
    </dialog>
  );
}
